import { UserPasskeyViewModel } from '@apis/model';
import { UserPasskeyUpdateFriendlyNameResponse } from '@ul/api';

export const toUserPasskeyViewModel = (
    response: UserPasskeyUpdateFriendlyNameResponse
): UserPasskeyViewModel | undefined => {
    return {
        responseCode: response.responseCode,
        success: response.success,
        passkey: response?.passkey,
    };
};
